import { createCustomEnum } from "./customEnum";

const ProductValues = createCustomEnum({
	Gateway: {
		name: "Gateway",
		value: 0,
		displayName: "Gateway",
	},
	Terminal: {
		name: "Terminal",
		value: 1,
		displayName: "Terminal",
	},
	/**
	 * @deprecated
	 */
	POS: {
		name: "POS",
		value: 2,
		displayName: "POS",
	},
	/**
	 * @deprecated
	 */
	ThrirdParty: {
		name: "ThrirdParty",
		value: 3,
		displayName: "3rd party",
	},
	CRM: {
		name: "CRM",
		value: 4,
		displayName: "CRM",
	},
	NailSoft: {
		name: "NailSoft",
		value: 6,
		displayName: "NailSoft",
	},
	/**
	 * @deprecated
	 */
	Other: {
		name: "Other",
		value: 5,
		displayName: "Other",
	},
	SalonInBox: {
		name: "SalonInABox",
		value: 7,
		displayName: "Salon in a Box",
	},
	PAX: {
		name: "PAX",
		value: 8,
		displayName: "PAX",
	},
	Dejavoo: {
		name: "Dejavoo",
		value: 9,
		displayName: "Dejavoo",
	},
	Sunmi: {
		name: "Sunmi",
		value: 10,
		displayName: "Sunmi",
	},
	Clover: {
		name: "Clover",
		value: 11,
		displayName: "Clover",
	},
	Ingenico: {
		name: "Ingenico",
		value: 12,
		displayName: "Ingenico",
	},
	AMP: {
		name: "AMP",
		value: 13,
		displayName: "AMP",
	},
	Valor: {
		name: "Valor",
		value: 14,
		displayName: "Valor",
	},

	NMI: {
		name: "NMI",
		value: 15,
		displayName: "NMI",
	},
	AuthNet: {
		name: "AuthNet",
		value: 16,
		displayName: "Auth.net",
	},
	ARISE: {
		name: "ARISE",
		value: 17,
		displayName: "ARISE",
	},
	USAePay: {
		name: "USAePay",
		value: 18,
		displayName: "USA ePay",
	},
	PayTrace: {
		name: "PayTrace",
		value: 19,
		displayName: "Pay Trace",
	},
	SwipeSimple: {
		name: "SwipeSimple",
		value: 20,
		displayName: "Swipe Simple",
	},
	PayflowPro: {
		name: "PayflowPro",
		value: 21,
		displayName: "Payflow Pro",
	},
	Straddle: {
		name: "Straddle",
		value: 22,
		displayName: "Straddle",
	},
});

export default ProductValues;
